import { Auth } from "@aws-amplify/auth";

import { useCallback, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import UserInfoContext from "@/context/UserInfoContext";

const useCheckUserStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const userInfoContext = useContext(UserInfoContext);

  const checkUserStatus = useCallback(async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();

      if (user) {
        userInfoContext.setUserInfo({
          email: user.attributes.email,
          token: user.signInUserSession.idToken.jwtToken,
          profile_img: user.attributes?.picture,
        });

        if (["/auth"].includes(location.pathname)) {
          navigate("/", { replace: true });
        }
      } else {
        return true;
      }
    } catch (error) {
      return true;
    }
  }, [location.pathname, navigate, userInfoContext]);

  return {
    checkUserStatus,
  };
};

export default useCheckUserStatus;
